export default function Footer() {
  return <footer>Developed by Parth</footer>;
}
